// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import SplitType from "split-type";

// gsap.registerPlugin(ScrollTrigger);

// export const LandingPageAnimations = () => {
//   // Hero text split and animate
//   const split = new SplitType(".hero-text", { types: ["lines", "words"] });

//   gsap.from(split.words, {
//     opacity: 0,
//     y: 30,
//     stagger: 0.05,
//     duration: 0.8,
//     ease: "power3.out",
//   });

//   // Hero background zoom (requires .hero-bg-wrapper class)
//   gsap.fromTo(
//     ".hero-bg-wrapper",
//     { scale: 1.2 },
//     {
//       scale: 1,
//       duration: 2.5,
//       ease: "power2.out",
//     }
//   );

//   // About section
//   gsap.fromTo(
//     ".about-section",
//     { x: -100, opacity: 0 },
//     {
//       scrollTrigger: {
//         trigger: ".about-section",
//         start: "top 80%",
//         toggleActions: "play none none none",
//       },
//       x: 0,
//       opacity: 1,
//       duration: 1,
//       ease: "power2.out",
//     }
//   );

//   // Spotlight
//   gsap.fromTo(
//     ".spotlight-section",
//     { opacity: 0, y: 80, scale: 0.95 },
//     {
//       scrollTrigger: {
//         trigger: ".spotlight-section",
//         start: "top 85%",
//         toggleActions: "play none none none",
//       },
//       opacity: 1,
//       y: 0,
//       scale: 1,
//       duration: 1,
//       ease: "power2.out",
//     }
//   );

//   // Metrics
//   gsap.fromTo(
//     ".metrics-section .metric-block",
//     { opacity: 0, y: 50 },
//     {
//       scrollTrigger: {
//         trigger: ".metrics-section",
//         start: "top 90%",
//         toggleActions: "play none none none",
//       },
//       stagger: 0.2,
//       opacity: 1,
//       y: 0,
//       duration: 0.8,
//       ease: "power2.out",
//     }
//   );

//   const splitTextEls = document.querySelectorAll(".split-body");

//   splitTextEls.forEach((el) => {
//     const split = new SplitType(el as HTMLElement, {
//       types: ["lines", "words"],
//     });

//     gsap.from(split.words, {
//       scrollTrigger: {
//         trigger: el,
//         start: "top 90%",
//         toggleActions: "play none none none",
//       },
//       opacity: 0,
//       y: 20,
//       stagger: 0.01,
//       duration: 0.6,
//       ease: "power2.out",
//     });
//   });

//   // Testimonials
//   gsap.fromTo(
//     ".testimonial-section",
//     { opacity: 0, y: 40 },
//     {
//       scrollTrigger: {
//         trigger: ".testimonial-section",
//         start: "top 90%",
//         toggleActions: "play none none none",
//       },
//       opacity: 1,
//       y: 0,
//       duration: 1,
//       ease: "power2.out",
//     }
//   );

//   // Images (float and fade)
//   gsap.utils.toArray(".image-animate").forEach((el: any) => {
//     gsap.fromTo(
//       el,
//       { opacity: 0, y: 50, scale: 0.95 },
//       {
//         scrollTrigger: {
//           trigger: el,
//           start: "top 90%",
//           toggleActions: "play none none none",
//         },
//         opacity: 1,
//         y: 0,
//         scale: 1,
//         duration: 1,
//         ease: "power2.out",
//       }
//     );
//   });
// };
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitType from "split-type";

gsap.registerPlugin(ScrollTrigger);

export const LandingPageAnimations = () => {
  const heroSplit = new SplitType(".hero-text", {
    types: ["lines", "words"],
  });

  gsap.from(heroSplit.words, {
    opacity: 0,
    y: 40,
    stagger: 0.04,
    duration: 1,
    ease: "power3.out",
  });

  gsap.fromTo(
    ".hero-bg-wrapper",
    { scale: 1.2 },
    { scale: 1, duration: 2.5, ease: "power2.out" }
  );

  gsap.from(".hero-cta", {
    opacity: 0,
    y: 20,
    delay: 0.6,
    duration: 0.8,
    ease: "power2.out",
  });

  gsap.from(".metric-block", {
    opacity: 0,
    y: 40,
    stagger: 0.2,
    duration: 0.8,
    ease: "power2.out",
  });

  document.querySelectorAll(".split-body").forEach((el) => {
    const split = new SplitType(el as HTMLElement, {
      types: ["lines", "words"],
    });

    gsap.from(split.words, {
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
      },
      opacity: 0,
      y: 20,
      stagger: 0.01,
      duration: 0.6,
      ease: "power2.out",
    });
  });

  gsap.utils
    .toArray([
      ".about-section",
      ".ecosystem-section",
      ".platform-section",
      ".how-section",
      ".africa-section",
      ".faq-section",
    ])
    .forEach((section: any) => {
      gsap.from(section, {
        scrollTrigger: {
          trigger: section,
          start: "top 85%",
        },
        opacity: 0,
        y: 60,
        duration: 1,
        ease: "power2.out",
      });
    });

  gsap.utils
    .toArray([".africa-feature", ".faq-item", ".platform-item"])
    .forEach((group: any) => {
      gsap.from(group, {
        scrollTrigger: {
          trigger: group,
          start: "top 90%",
        },
        opacity: 0,
        y: 30,
        duration: 0.6,
        ease: "power2.out",
      });
    });

  // gsap.utils
  //   .toArray([".about-card", ".ecosystem-card", ".how-card"])
  //   .forEach((group: any) => {
  //     gsap.from(group, {
  //       scrollTrigger: {
  //         trigger: group,
  //         start: "top 90%",
  //       },
  //       opacity: 0,
  //       y: 50,
  //       scale: 0.96,
  //       duration: 1,
  //       ease: "power2.out",
  //     });
  //   });

  gsap.utils.toArray(".image-animate").forEach((img: any) => {
    gsap.from(img, {
      scrollTrigger: {
        trigger: img,
        start: "top 90%",
      },
      opacity: 0,
      y: 50,
      scale: 0.96,
      duration: 1,
      ease: "power2.out",
    });
  });
};
